(ns frontend.view.nev.kyc.process-status-views.approved-status
  (:require [frontend.view.nev.kyc.process-status-views.edit-view :as edit-view]
            [frontend.state.current-session :as session]
            [frontend.view.nev.kyc.process-status-views.view-utils :as kvu]
            [frontend.actions.kyc-process :as kyc-process-actions]
            [frontend.logging :as logging]
            [common.localization :as loc]
            [frontend.view.entity-viewers.modules.attachments :as attachments]
            [ui.components.button.view :as button]))

(defn view [state-atom entity save! approved-modified-edit-mode?*]
  [edit-view/view {:state-atom      state-atom
                   :save!           save!
                   :entity          entity
                   :mandatory?      false
                   :read-only?      true
                   :lang            :en
                   :footer-renderer (fn [_state-atom _answers-atom entity]
                                      (let [entity-id (:db/id entity)
                                            attachments (->> entity
                                                             :common/attachments
                                                             (filter (fn [attachment-id]
                                                                       (or (= attachment-id (:kyc-process/signed-document entity))
                                                                           ;; template documents??
                                                                           )))
                                                             (map session/get-entity))]
                                        [:div.d-flex.flex-static.flex-column.kyc-submit-footer
                                         [:div
                                          {:class-name "container"}
                                          [:div
                                           {:class-name "grid grid-cols-10 gap-4 px-4"}
                                           [:div
                                            {:class-name "col-span-10"}
                                            [:div.attachment-list.px-0.pb-3
                                             (doall
                                              (for [attachment attachments]
                                                ^{:key (str "attachment-" entity-id "-" (or (:db/id attachment)
                                                                                            attachment))}
                                                [attachments/attachment-view {:attachment attachment
                                                                              :target-id  entity-id}]))]]
                                           [:div
                                            {:class-name "col-span-5"}
                                            [kvu/exit-button entity :en]]
                                           [:div
                                            {:class-name "col-span-5"}
                                            [:div.d-flex.justify-content-end
                                             [button/primary-solid
                                              {:on-click (fn [_]
                                                           (kyc-process-actions/*->modify-after-approval! {:kyc-process-id (:db/id entity)}
                                                                                                          (fn [_resp]
                                                                                                            (reset! approved-modified-edit-mode?* true))
                                                                                                          (fn [resp]
                                                                                                            (logging/error "Failed to complete KYC " resp))))}
                                              (loc/tr :modify-after-approval)]]]]]]))}])

